module.exports = __webpack_public_path__ + "img/no-image.38ae0e1b.jpg";